import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  makeStyles,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import AddIcon from '@material-ui/icons/Add';
import useDeviceDetect from '../../../hooks/useDeviceDetect';
import { blueBar } from '../../../helpers/common';
import SelectNodeLabel from '../../InstantAdvanced/SelectNodeLabel';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import VariableSelectorReport from '../VariableSelectorReports';

let scrollsSettings = {
  overflow: 'scroll',
  overflowX: 'hidden',
};
let webkitScrollbar = {
  background: 'white',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#beb1b18f',
  color: 'red',
  width: '9px',
};
let webkitscrollbarTrack = {
  background: '#dfdfe957',
};
const useStyles = makeStyles(theme => ({
  root: {
    ...scrollsSettings,
    '&::-webkit-scrollbar': {
      //son los estilos de las barras scroll en una variable.
      ...webkitScrollbar,
    },
    '&::-webkit-scrollbar-track': {
      //son los estilos de las barras scroll en una variable.
      ...webkitscrollbarTrack,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
    },
    '& .MuiGrid-root': {
      padding: theme.spacing(1),
    },
    steppersFilter: {
      '&.MuiStep-horizontal': {
        paddingLeft: '0',
        paddingRight: '0',
      },
    }
  },
  btn: {
    margin: theme.spacing(3, 1),
  },
  leftSpacing: {
    marginLeft: theme.spacing(1),
  },
  hint: {
    backgroundColor: 'rgba(0, 0, 0, 0.38)',
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    minWidth: '25px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'rgb(54, 143, 193);',
    },
  },
  tick: {
    backgroundColor: theme.palette.success.light,
  },
  active: {
    backgroundColor: theme.palette.primary.main,
  },
  devicesLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
  },
  addBtn: {
    margin: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    '&:hover': {
      backgroundColor: 'rgb(54, 143, 193);',
    },
  },
  pending: {
    color: '#af2c47',
    fontSize: '0.75rem',
    padding: theme.spacing(0.5),
    textAlign: 'center'
  },
}));

export default function DatasetFilter({
  setShowDatasetFilter,
  selectedDataset,
  setFilterOptions,
  filterOptions,
  indexDatasetSelected,
  statusNodes,
  variables,
  hasSomeVirtualNodes,
  objectCatalog,
  nodes,
  automateVars
}) {
  const classes = useStyles();
  const { isMobile } = useDeviceDetect(990);

  const steps = [
    'Elija un dispositivo',
    'Seleccione una variable'
  ];
  const blueLine = blueBar();
  const [dataset, setDataset] = useState({});
  const [showDevices, setShowDevices] = useState(false);
  const [nodeLabelSelected, setNodeLabelSelected] = useState({});
  const [activeStep, setActivestep] = useState(0);
  const [variablesToShow, setVariablesToShow] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    initDataset();
  }, []);

  const initDataset = async () => {
    if (selectedDataset?.extra_info?.vars) {
      let selectedNodes = []
      selectedDataset?.nodes?.forEach(node => {
        const foundNode = findNodeById(nodes, Number(node));
        if (foundNode) {
          selectedNodes.push(foundNode);
        }
      })
      const varKeys = selectedDataset.extra_info.vars.split(",").map(s => s.trim())
  .map(s => Number(s.split(' ')[1]))

      let selectedVars = []
      for (const key of varKeys) {
        let varFromAutomate = automateVars.find(variable => variable.key === JSON.stringify(key));
        if (varFromAutomate) {
          selectedVars.push(varFromAutomate);
        }
      }
      
      if (selectedVars.length > 0) {
        setDataset({
          devices: selectedNodes,
          variables: selectedVars,
        });
      }
      setVariablesToShow([...automateVars])
    }
    else {
      let selectedVars = !Array.isArray(selectedDataset?.variables) ? selectedDataset?.variables?.split(',') : selectedDataset?.variables;
      let selectedNodes = []
      selectedDataset?.nodes?.forEach(node => {
        const foundNode = findNodeById(nodes, Number(node));
        if (foundNode) {
          selectedNodes.push(foundNode);
        }
      })
      setDataset({
        variables: selectedVars,
        devices: selectedNodes,
      })
      setVariablesToShow(variables)
    }
  }

  const previousAutomateSelected = () => {
    return filterOptions.datasets.some(dataset => dataset.extra_info?.vars)
  }

  const previosDevicesSelected = () => {
    return filterOptions.datasets.some(dataset => !dataset.extra_info?.vars)
  }

  useEffect(() => {
    if ((!dataset.devices || dataset.devices.length === 0) && !(!dataset.variables || dataset.variables.length === 0)) {
      setActivestep(0);
    } else if ((dataset.devices && dataset.devices.length > 0) && (!dataset.variables || dataset.variables.length === 0)) {
      setActivestep(1);
    } else if ((dataset.devices && dataset.devices.length > 0) && (dataset.variables && dataset.variables.length > 0)) {
      setActivestep(2);
    }
  }, [dataset])

  useEffect(() => {
    if (nodeLabelSelected?.selectedNodes) {
      setError(null);
      let devices = nodeLabelSelected?.selectedNodes
      // if (nodeLabelSelected?.selectedNodes.length !== 1) {
      //   setActivestep(0);
      // }
      // transformo ids a string
      devices = devices.map(device => ({ ...device, id: device.id.toString() }));
      if (nodeLabelSelected.selectedLabel) {
        let { id, nombre } = nodeLabelSelected.selectedLabel;
        devices[0].label_id = id;
        devices[0].label_nombre = nombre;
      }
      if (!dataset.devices) {
        setActivestep(1);
      }
      // busco automates siempre en el primer device seleccionado ya que solo se puede seleccionar un nodo con automate
      if (devices[0]?.automates?.length > 0) {
        getAutomateVars(devices); 
      } else {
        // si no hay automates seleccionados, saco las variables de automate del listado
        let newVariables = variables.filter(variable => !variable.isVarAutomate);
        setVariablesToShow(newVariables)
      }
      setDataset(prevDataset => ({
        ...prevDataset,
        devices,
        variables: null,
      }));
    }
  }, [nodeLabelSelected]);

  const mergeUnique = (a = [], b = []) => [...new Set([...a, ...b])];

  const handleMultipleNodes = (selectedNodes) => {
    setFilterOptions(prev => {
      let datasets = [...prev.datasets];

      selectedNodes.forEach(node => {
        const index = datasets.findIndex(ds =>
          ds.nodes.some(n => n === node.id)
        );

        if (index !== -1) {
          // 🔁 Nodo existente → merge variables
          datasets[index] = {
            ...datasets[index],
            variables: mergeUnique(
              datasets[index].variables,
              dataset.variables
            ),
            alias: `${node.nombre} (${mergeUnique(datasets[index].variables, dataset.variables).length} variables)`
          };
        } else {
          // 🆕 Nodo nuevo → crear dataset
          datasets.push({
            id: null,
            nodes: [node.id],
            variables: [...dataset.variables],
            extra_info: {},
            alias: `${node.nombre} (${dataset.variables.length} variables)`
          });
        }
      });

      return {
        ...prev,
        datasets
      };
    });
  };


  const findNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }

      if (Array.isArray(node.hijos) && node.hijos.length > 0) {
        const found = findNodeById(node.hijos, id);
        if (found) return found;
      }
    }
    return null;
  };

  const getAutomateVars = async (automatesSelected) => {
    let automateVarsToShow = [];
    if (automateVars.length > 0) {
      for (let variable of automateVars) {
        let belongsToAutomate = automatesSelected?.[0]?.automates?.[0]?.llave === variable.group.key;
        variable.isVarAutomate = true;
        if (belongsToAutomate) {
          automateVarsToShow.push(variable);
        }
      }
      let newVariables = [...automateVarsToShow];
      setVariablesToShow(newVariables)
    }
  }

  const handleSubmit = () => {
    if (dataset?.devices?.length > 1) {
      handleMultipleNodes(dataset?.devices)
    } else {
      let datasetBuilt = buildObjectDataset();
      let filterAux = { ...filterOptions }
      let existentDataset = filterOptions?.datasets[indexDatasetSelected]
      if (existentDataset) {
        filterAux.datasets[indexDatasetSelected] = datasetBuilt;
      }
      else {
        filterAux.datasets.push(datasetBuilt);
      }
      setFilterOptions(filterAux);
    }

    setShowDatasetFilter(false);
  };

  const handleOpenCloseSelectNodeTag = () => {
    setShowDevices(!showDevices);
  };

  const handleCancel = () => {
    setShowDatasetFilter(false);
  };

  const handleDeleteDevice = index => {
    let devices = [...dataset.devices];
    devices.splice(index, 1);
    setDataset({
      ...dataset,
      devices: devices,
    });
  };

  const buildObjectDataset = () => {
    let selectedNodes = dataset?.devices.map(device => device.id);
    let varsAutomateSelected = dataset.variables.some(item => item?.group?.key)
    let varsExtraInfo = "";
    let devicesNames = dataset?.devices.map(device => device.nombre).join(", ");

    let objDataset = {
      id: selectedDataset?.id || null,
      nodes: selectedNodes,
      variables: dataset?.variables,
      extra_info: {},
      alias: `${devicesNames} (${dataset.variables.length} variables)`
    }

    if (varsAutomateSelected === true) {
      varsExtraInfo = dataset.variables.map(item => `${item?.group?.key} ${item?.key}`).join(", ")
      objDataset.extra_info = {
        vars: varsExtraInfo
      }
      objDataset.variables = ["VARIABLES_PERSONALIZADAS_AUTOMATE"]
    }

    return objDataset;
  }


  return (
    <Box className={classes.root}>
      <Stepper
        className={classes.steppersFilter}
        activeStep={activeStep}
        alternativeLabel
      >
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{isMobile ? '' : label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <form width="100%">
        {blueLine}
        <Grid container style={{ padding: 8 }} width="100%">
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={2}>
              <Tooltip
                title="Elija el/los dispositivos que desea añadir al reporte"
                arrow
                placement="right"
              >
                <Box
                  className={clsx(
                    classes.hint,
                    classes.leftSpacing,
                    { [classes.active]: activeStep === 0 },
                    { [classes.tick]: activeStep > 0 }
                  )}
                >
                  1
                </Box>
              </Tooltip>
              <Box className={classes.devicesLabel}>Agregar dispositivo</Box>
              <IconButton
                className={classes.addBtn}
                onClick={() => {
                  setShowDevices(true);
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>

              {dataset?.devices?.map((node, index) => (
                <Chip
                  key={node.id}
                  icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                  label={`${node.nombre}
                          ${node.label_nombre ? ` + ${node.label_nombre}` : ''
                    }`}
                  clickable
                  color="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => handleOpenCloseSelectNodeTag('edit')}
                  onDelete={() => handleDeleteDevice(index)}
                />
              ))}
              {(!dataset.devices || dataset?.devices?.length === 0) && (
                <Box
                  ml={1}
                  mt={1}
                  className={classes.devicesLabel}
                  width={'100%'}
                >
                  Debe seleccionar al menos un dispositivo.
                </Box>
              )}
              <Box
                ml={1}
                mt={1}
                className={classes.devicesLabel}
                width={'100%'}
              >
                Nota: Si selecciona múltiples dispositivos se creará un dataset
                para cada uno.
              </Box>
            </Box>
          </Grid>

          {/* Variable */}
          <Grid item xs={12}>
            <Box display='flex' alignItems='center'>
              <Tooltip
                title='Elija la variable sobre la cual desea obtener el reporte'
                arrow
                placement='right'
              >
                <Box className={clsx(
                  classes.hint,
                  classes.leftSpacing,
                  { [classes.active]: activeStep === 1 },
                  { [classes.tick]: activeStep > 1 }
                )}>2</Box>
              </Tooltip>
              <VariableSelectorReport
                variables={variablesToShow}
                dataset={dataset}
                setDataset={setDataset}
                hasSomeVirtualNodes={hasSomeVirtualNodes}
                objectCatalog={objectCatalog}
              />

            </Box>
          </Grid>

        </Grid>

        {blueLine}

        {
          error && (
            <Box className={classes.pending}>
              {error}
            </Box>
          )
        }

        <Box display={'flex'} justifyContent={'center'} width={'100%'}>
          <Button
            variant="contained"
            color="primary"
            className={classes.btn}
            onClick={handleSubmit}
            disabled={!dataset?.devices || (!dataset.variables || dataset?.variables?.length === 0) || error}
          >
            Aceptar
          </Button>

          <Button
            variant="contained"
            onClick={handleCancel}
            className={classes.btn}
          >
            Cancelar
          </Button>
        </Box>
      </form>
      {showDevices && (
        <SelectNodeLabel
          showDevices={showDevices}
          setNodeLabelSelected={setNodeLabelSelected}
          handleOpenCloseSelectNodeTag={handleOpenCloseSelectNodeTag}
          multi={true}
          statusNodes={statusNodes}
        />
      )}
    </Box>
  );
}
